import { alias, object, primitive, serializable, serialize } from "serializr";
import { ExamSubjectModel } from "../exam.model";

export class ExamChapterModel{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('name', primitive()))
    name?: string;
    @serializable(alias('title', primitive()))
    title?: string;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('position', primitive()))
    position?: string;
    @serializable(alias('exam_subject', object(ExamSubjectModel)))
    examSubject?: string;
    @serializable(alias('description', primitive()))
    description?: string;
    @serializable(alias('exam_subject_id', primitive()))
    examSubjectId?: string;
}
